import React from 'react'
import './Tabs.css'
import tab1img1 from './../../Images/ios-c79aced2503a1216d930cf64b8775c35.png'
import tab1img2 from './../../Images/android-5b70ed453f90b82dacce51e6970c4e67.png'
import tab1img3 from './../../Images/react-f3e576ba08e6be927148e87ad9c79ac6.png'
import tab1img4 from './../../Images/download (2).png';
import tab2img1 from './../../Images/react-f3e576ba08e6be927148e87ad9c79ac6.png'
import tab2img2 from './../../Images/gaytsby-e0fc01a9a0a5c4198be67d2cf16e935c.png'
import tab2img3 from './../../Images/typescript-1a203e65baa39b0b972d571e6257a036.png'
import tab2img4 from './../../Images/html-91c24f93ff8755047a4d59ecea390b7a.png'
import tab2img5 from './../../Images/css-b1dc9eeb13b9837cea03e95d234b08d4.png'
import tab3img1 from './../../Images/mongodb-bdcaeb2d267ec943d838e608e3723d0c.png'
import tab3img2 from './../../Images/firebase-a5f9f1fd96c36040dd434f71d5765c29.png'
import tab3img3 from './../../Images/DynamoDB-fc665d2753c94744d5a5fe52faf83c3b.png'
import tab4img1 from './../../Images/nodejs-8e341cc00e4ec40c6a2708bfec56b60f.png'
import tab5img1 from './../../Images/cms-8b2c551d15ad50445904c39a3f5d1c6d.png'
import tab6img1 from './../../Images/aws-116b0d268d8b875c6fa55c98cad07302.png'
export default function Tabs() {
  return (
    <div>
          <ul className="nav nav-pills Tabs_Header" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="pills-Mobile-tab" data-bs-toggle="pill" data-bs-target="#pills-Mobile" type="button" role="tab" aria-controls="pills-Mobile" aria-selected="true">Mobile</button>
              </li>
              <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-frontend-tab" data-bs-toggle="pill" data-bs-target="#pills-frontend" type="button" role="tab" aria-controls="pills-frontend" aria-selected="false">Front End</button>
              </li>
              <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-database-tab" data-bs-toggle="pill" data-bs-target="#pills-database" type="button" role="tab" aria-controls="pills-database" aria-selected="false">Database</button>
              </li>
              <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-backend-tab" data-bs-toggle="pill" data-bs-target="#pills-backend" type="button" role="tab" aria-controls="pills-backend" aria-selected="false">Backend</button>
              </li>
              <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-cms-tab" data-bs-toggle="pill" data-bs-target="#pills-cms" type="button" role="tab" aria-controls="pills-cms" aria-selected="false">CMS</button>
              </li>
              <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-devops-tab" data-bs-toggle="pill" data-bs-target="#pills-devops" type="button" role="tab" aria-controls="pills-devops" aria-selected="false">Devops</button>
              </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
              <div className="tab-pane fade show active" id="pills-Mobile" role="tabpanel" aria-labelledby="pills-Mobile-tab">
                  <div className="col-lg-3 col-md-6 col-xs-6">
                    <div className="project-boxes">
                          <img src={tab1img1} style={{ width: "40px" }} />
                        <div className="content">
                            IOS
                        </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab1img2} />
                          <div className="content">
                              Android
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab1img3} />
                          <div className="content">
                              React Native
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab1img4} />
                          <div className="content">
                              Expo
                          </div>
                      </div>
                  </div>
              </div>
              <div className="tab-pane fade" id="pills-frontend" role="tabpanel" aria-labelledby="pills-frontend-tab">
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab2img1}/>
                          <div className="content">
                              React Js
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab2img2} />
                          <div className="content">
                              Gatsby Js
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab2img3} />
                          <div className="content">
                              TypeScript
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab2img4} />
                          <div className="content">
                              HTML5
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab2img5} />
                          <div className="content">
                              CSS3
                          </div>
                      </div>
                  </div>
              </div>
              <div className="tab-pane fade" id="pills-database" role="tabpanel" aria-labelledby="pills-database-tab">
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab3img1} />
                          <div className="content">
                              Mongo DB
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab3img2} />
                          <div className="content">
                              Firebase
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab3img3} />
                          <div className="content">
                              DynamoDB
                          </div>
                      </div>
                  </div>
              </div>
              <div className="tab-pane fade" id="pills-backend" role="tabpanel" aria-labelledby="pills-backend-tab">
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab4img1} />
                          <div className="content">
                              Node.JS
                          </div>
                      </div>
                  </div>
              </div>
              <div className="tab-pane fade" id="pills-cms" role="tabpanel" aria-labelledby="pills-cms-tab">
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab5img1} />
                          <div className="content">
                              WordPress
                          </div>
                      </div>
                  </div>
              </div>
              <div className="tab-pane fade" id="pills-devops" role="tabpanel" aria-labelledby="pills-devops-tab">
                  <div className="col-lg-3 col-md-6 col-xs-6">
                      <div className="project-boxes">
                          <img src={tab6img1} />
                          <div className="content">
                              AWS
                          </div>
                      </div>
                  </div>
              </div>
          </div>
    </div>
  )
}
